export const cognitoGroupType = {
  SUPER_ADMIN: 'super_admin',
  MEMBER_SERVICES: 'member_services',
  MANAGER: 'manager',
  ADMIN: 'admin',
  ACCOUNT_EXECUTIVE: 'account_executive',
  BUSINESS_CONSULTANT: 'business_consultant',
  SYSTEM_ADMIN: 'system_admin',
};
